import "../styles/AccessFeatures.css";
import {
  FaBook,
  FaChalkboardTeacher,
  FaVideo,
  FaQuestionCircle,
  FaClipboardList,
} from "react-icons/fa";

const row1 = [
  { text: "Flashcards", icon: <FaBook /> },
  { text: "Career Guidance", icon: <FaChalkboardTeacher /> },
  { text: "Live Classes", icon: <FaVideo /> },
  { text: "24×7 Doubt Solving", icon: <FaQuestionCircle /> },
  { text: "Mock Tests", icon: <FaClipboardList /> },
];

const row2 = [
  { text: "Meditation Session", icon: <FaBook /> },
  { text: "Revision Notes", icon: <FaBook /> },
  { text: "PYQ Tests", icon: <FaClipboardList /> },
  { text: "Mentorship", icon: <FaChalkboardTeacher /> },
  { text: "Improvement Book", icon: <FaBook /> },
];

const row3 = [
  { text: "PYQ Practice", icon: <FaClipboardList /> },
  { text: "Topic-wise Tests", icon: <FaClipboardList /> },
  { text: "Regular Homework", icon: <FaBook /> },
  { text: "Topic-wise Videos", icon: <FaVideo /> },
  { text: "Subjective Tests", icon: <FaClipboardList /> },
];

function Row({ items, reverse }) {
  return (
    <div className="marquee fade">
      <div className={`marquee-inner ${reverse ? "reverse" : ""}`}>
        {[...items, ...items, ...items].map((item, i) => (
          <div className="pill" key={i}>
            <span className="icon">{item.icon}</span>
            <span>{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function AllenFeatures() {
  return (
    <section className="allen">
      <h2>
        Learn more about <span>
          <img src="/images/access.png"
              alt="ACCESS"
              className="acces-img"/></span>
      </h2>

      <Row items={row1} />
      <Row items={row2} reverse />
      <Row items={row3} />
    </section>
  );
}
